/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import HeaderNotifPresenter from './HeaderNotifPresenter';

import DTOHeaderNotification from './DTOHeaderNotification';
import { getUpdateReadAt } from '../../configs/utils';
import _ from 'lodash';
import { useAppSelector } from '../../../infra/hooks';
interface ModalInterface {
  isOpen: boolean;
  onCloseModal: any;
  // setUnReadCount: any;
}
const HeaderNotifController = ({
  isOpen,
  onCloseModal,
}: // setUnReadCount,
ModalInterface) => {
  const [headerNotifData, setHeaderNotifData] = useState([]);
  const selector = useAppSelector((state) => state);
  function callBackFunc(data: any) {
    setHeaderNotifData(data);
  }
  function UpdateReadAt(data: any) {
    const id = data?.row ? data?.row?.id : data?.id;
    const table = data?.row ? data?.row?.datafrom : data?.datafrom;
    const emp_id = selector.authSlice.emp_id;
    getUpdateReadAt(id, table, emp_id).then((res: any) => {
      const tempnotilist = [...headerNotifData];

      const newlist: any = _.filter(tempnotilist, (d: any) => {
        return d.id != res?.id;
      });
      setHeaderNotifData(newlist);
    });
  }

  return (
    <div>
      <DTOHeaderNotification setheaderNotif={callBackFunc} />
      <HeaderNotifPresenter
        isOpen={isOpen}
        onCloseModal={onCloseModal}
        HeaderNotifData={headerNotifData}
        calltoupdateread={UpdateReadAt}
      />
    </div>
  );
};
export default HeaderNotifController;
